module.exports = __webpack_public_path__ + "static/media/fcc.7b4fe6e1.jpg";